export const handleIframeMessage = (event: MessageEvent) => {
  if (!event.data || (!event.type && event.type !== 'message')) return;

  return event.data;
};
